import React from "react";
import { Container } from "react-bootstrap";

export default function TermsConditions() {
  return (
    <Container className="py-5">
      <h2>Terms and Conditions</h2>
      <p className="mt-3">
        Welcome to <strong>TickTickGo</strong>. By accessing or using our services,
        you agree to comply with our terms and policies.
      </p>
      <ul>
        <li>Use the platform responsibly and lawfully.</li>
        <li>
          You are responsible for maintaining the confidentiality of your account credentials.
        </li>
        <li>
          TickTickGo reserves the right to update, modify, or discontinue any feature at any time.
        </li>
        <li>
          All content, trademarks, and materials belong to TickTickGo unless stated otherwise.
        </li>
      </ul>
      <p>
        By using our services, you acknowledge that you have read and agree to
        these terms and our privacy policy.
      </p>
    </Container>
  );
}
